import React from "react";
import { Link } from "react-router-dom";
import "./Footer.css";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="site-footer">
      <div className="footer-content">
        <div className="footer-brand">
          <span className="footer-logo">StoryBuddy</span>
          <p className="footer-tagline">AI-powered stories for curious minds</p>
        </div>
        <nav className="footer-links">
          <Link to="/">Discover</Link>
          <Link to="/create">Create</Link>
          <Link to="/knowledge">Learn</Link>
          <Link to="/about">About Us</Link>
        </nav>
      </div>
      <div className="footer-bottom">
        <p>&copy; {currentYear} StoryBuddy. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
